import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { OtherFinancialItem } from '../types'
import CellPrice from '@/components/GokuDataGrid/CellPrice'

export const columns: (t: Function) => GridColDefVNW<OtherFinancialItem>[] = (
    t
) => [
    {
        field: 'report_month',
        headerName: 'report_month',
        width: 150,
    },
    {
        field: 'item_type',
        headerName: 'item_type',
        width: 130,
        renderCell: ({ value }) => {
            const isRevenue = value === 'revenue'
            return (
                <span
                    className={`inline-flex items-center px-2 py-1 rounded text-xs ${
                        isRevenue
                            ? 'bg-green-100 text-c-success'
                            : 'bg-red-100 text-c-error'
                    }`}
                >
                    {isRevenue ? t('revenue') : t('expense')}
                </span>
            )
        },
    },
    {
        field: 'item_name',
        headerName: 'item_name',
        width: 250,
        flex: 1,
    },
    {
        field: 'amount',
        headerName: 'amount',
        width: 180,
        align: 'right',
        renderCell: ({ value, row }) => (
            <CellPrice
                price={value}
                className={
                    row.item_type === 'revenue'
                        ? 'text-green-700'
                        : 'text-red-700'
                }
            />
        ),
    },
    {
        field: 'notes',
        headerName: 'notes',
        width: 300,
        renderCell: ({ value }) => (
            <div className="text-sm text-gray-600 truncate">{value || '-'}</div>
        ),
    },
]
